import { useState } from 'react';
import menu from 'images/sprite.svg';
import { MobileMenu } from 'components/Sidebar/MobileMenu/MobileMenu';
import { MobileMenuBox } from 'components/Sidebar/MobileMenu/MobileMenu.styled';
import {
  Header,
  HeaderContainer,
  HeaderNav,
  HeaderSvg,
  LogoBox,
  LogoImg,
  NavButton,
} from './Header.styled';
import Logo from '../../images/logo.png';
import { NavLink, useLocation } from 'react-router-dom';
import Language from 'components/Language/Language';
import { LanguageDiv } from 'components/Language/Language.styled';
import { useTranslation } from 'react-i18next';

export const HeaderComp = ({ footerRef }) => {
  const [isOpen, setIsOpen] = useState(false);
  // const [visible] = useState(true); //setVisible
  const location = useLocation();
  const { t } = useTranslation();
  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleScrollToFooter = () => {
    if (footerRef?.current) {
      footerRef.current.scrollIntoView({ behavior: 'smooth' });
      setIsOpen(false);
    }
  };

  return (
    <>
     {/* isVisible={visible} */}
      <Header>
        <HeaderContainer>
          <LogoBox href="/" aria-label="logo company">
            <LogoImg src={Logo} alt="logo" />
          </LogoBox>

          <HeaderNav>
            <ul>
              <li>
                <NavLink
                  className={`link ${
                    location.pathname === '/' ? 'active' : ''
                  }`}
                  to="/"
                  aria-label="Home"
                >
                  Home
                </NavLink>
              </li>
              <li>
                <NavLink
                  className={`link ${
                    location.pathname === '/' ? 'active' : ''
                  }`}
                  to="/menu"
                  aria-label="Menu"
                >
                  {t('Speisekarte')}
                </NavLink>
              </li>
              <li>
                <NavButton
                  onClick={handleScrollToFooter}
                  aria-label="Contacts"
                  className={`link ${
                    location.pathname === '/' ? 'active' : ''
                  }`}
                >
                  {t('Kontakte')}
                </NavButton>
              </li>
            </ul>
          </HeaderNav>
          <LanguageDiv>
            <Language />
          </LanguageDiv>

          <HeaderSvg width="24" height="24" onClick={toggleMenu}>
            <use href={menu + '#menu'}></use>
          </HeaderSvg>
          <MobileMenuBox className={`collapsed ${isOpen ? 'is-expanded' : ''}`}>
            <MobileMenu
              isOpen={isOpen}
              toggleMenu={toggleMenu}
              setIsOpen={setIsOpen}
              footerRef={footerRef}
            />
          </MobileMenuBox>
        </HeaderContainer>
      </Header>
    </>
  );
};
